import axios from 'axios'
import { store } from '../state/store'
import AuthService from '@services/auth.service'
import userService from '@services/business/user.service'

const ApiService = {
  init() {
    if (process.env.VUE_APP_ROOT_API) {
      axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
    }
    axios.defaults.headers.common['API-KEY-TECH'] = process.env.VUE_APP_API_KEY
  },

  setHeader() {
    AuthService.getAccessToken().then(function(response) {
      axios.defaults.headers.common.Authorization = `bearer ${response.access_token}`
      userService.getUserInfoByUserName()
    })

    // TODO: this will go away in future when we have the Sentinet headers adjusted to not require
    axios.defaults.headers['auth-key'] =
      store.state.currentJob.jobEmployeeNumber
  },

  removeHeader() {
    axios.defaults.headers.common = {}
  },

  get(resource) {
    return axios.get(resource).catch((err) => {
      if (err.response != null && err.response.status === 401) {
        AuthService.Login()
      }
      throw err
    })
  },

  post(resource, data) {
    return axios.post(resource, data).catch((err) => {
      if (err.response != null && err.response.status === 401) {
        AuthService.Login()
      }
      throw err
    })
  },

  put(resource, data) {
    return axios.put(resource, data).catch((err) => {
      if (err.response != null && err.response.status === 401) {
        AuthService.Login()
      }
      throw err
    })
  },

  delete(resource) {
    return axios.delete(resource).catch((err) => {
      if (err.response != null && err.response.status === 401) {
        AuthService.Login()
      }
      throw err
    })
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data).catch((err) => {
      if (err.response != null && err.response.status === 401) {
        AuthService.Login()
      }
      throw err
    })
  },
}

export default ApiService
